export default __webpack_public_path__ + "static/media/quicksight.82248f29.jpg";